import * as React from 'react'
import { SystemBase } from '../../library/common/SystemBase';
import PhoneInput, { Country, formatPhoneNumber, formatPhoneNumberIntl, isValidPhoneNumber } from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { getCodeFromAlpha } from '../../library/common/Country';
import HttpService from '../../service/httpService';

interface ISystemPhoneInput {
    DialCode: string,
    MaxLength: string,

}
export interface ISystemPhoneInputState {
    DefaultCountry?: string,
    DialCode?(data: any): void
}

export default class SystemPhoneInput extends SystemBase<any, ISystemPhoneInput & ISystemPhoneInputState>{
    static defaultProps = {
        ...SystemBase.defaultProps,
    }
    constructor(props: any) {
        super(props)
    }

    onCountryChange = async (country: Country) => {
        var dcode = getCodeFromAlpha(country as string);
        var max = 0;
        var data = await HttpService.get('ReferenceCountry/GetCountryDetailByCountryCode/' + country)
        if (dcode && !data.data) {
            max = 15;
        }
        else {
            max = data.data.MaxNumber

        }
        this.setState({ DialingCode: dcode, MaxLength: max });


        var PhoneNo = { "DialCode": dcode, "MaxLength": max };
        this.props.DialCode && this.props.DialCode(PhoneNo);
    }



    keyDownHandleChange = (event: any, name: string, value: any, text: string) => {
       

        let input = event.target.value;
        var ContactNumber = formatPhoneNumber(input);
        
        var regex = new RegExp("^[0-9]+$");

        if (event.keyCode == 9 || event.keyCode == 17 || event.keyCode == 86 || event.keyCode == 67) return;

       // var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        if (event.keyCode != 37 && event.keyCode != 38 && event.keyCode != 39 && event.keyCode != 40) {
            if (!regex.test(event.key)) {
                event.preventDefault();
                return false;
            }        

            else if (this.props.value && this.props.value.replace(this.state.DialingCode, "").length + 1 > this.state.MaxLength) {
                event.preventDefault();
                return false;
            }
        }
      
    }

    componentDidMount() {       

        if (this.props.DefaultCountry != undefined && this.props.value) {
            this.onCountryChange(this.props.DefaultCountry);
        }
    }


    handleOnChange = (value: any) => {

        this.handleChange(null, value, value);
    }
    onHandleBlur = (value: any) => {
        let { DialingCode, MaxLength } = this.state;
        var PhoneNo = { "DialCode": DialingCode, "MaxLength": MaxLength };
        this.props.DialCode && this.props.DialCode(PhoneNo);
    }

    render() {

        return (
            <this.WrapperDiv title={this.props.value as string}>
                <PhoneInput
                    {...this.props}
                    onChange={this.handleOnChange}
                    international={true}
                    className="form-control phone-input-styling"
                    value={this.props.value}
                    defaultCountry={this.props.DefaultCountry}
                    onCountryChange={this.onCountryChange}
                    onKeyDown={this.keyDownHandleChange}
                    onBlur={this.onHandleBlur}
                    id={this.props.id}
                    name={this.props.name}
                />
            </this.WrapperDiv>
        )
    }
}





/*import * as React from 'react'
import { SystemBase } from '../common/SystemBase';
import { Input } from '@progress/kendo-react-inputs';
import PhoneInput, { Country, formatPhoneNumber, formatPhoneNumberIntl, isValidPhoneNumber } from 'react-phone-number-input'
import 'react-phone-number-input/style.css'

interface ISystemPhoneInputProps {
    defaultCountry?: Country;
    limitMaxLength?: boolean
    international?: boolean
    onCountryChange?(country?: Country): void;
}

*//**
 * Creates an Input with Label  
 * *//*
export default class SystemPhoneInput extends SystemBase<ISystemPhoneInputProps>
{
    constructor(props: any) {
        super(props)
    }

    handleOnChange = (value) => {        
        this.handleChange(null, value, value);       
    }

    render() {
        return (
            <this.WrapperDiv title={this.props.value as string}>
                <PhoneInput                    
                    {...this.props}
                    onChange={this.handleOnChange}
                    className="form-control phone-input-styling"
                    value={this.state.value }
                    //error={this.state.value ? (isValidPhoneNumber(this.state.value ) ? undefined : 'Invalid phone number') : 'Phone number required'}
                />
            </this.WrapperDiv>
        );
    }
}*/



